import 'weixin-js-sdk'
import Vue from 'vue'
import store from '../store'
function dataURLtoBlob(dataurl) {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}

//将blob转换为file
function blobToFile(theBlob, fileName) {
  theBlob.lastModifiedDate = new Date()
  theBlob.name = fileName
  return theBlob
}

class WxSDKService {
  constructor() {
    this.jsApiList = [
      'checkJsApi', //检测接口权限
      'updateTimelineShareData', //1.4.0的分享接口，注意：使用新版本的分享功能，一定要在该列表加上对应的老版本功能接口，否则新接口不起作用
      'updateAppMessageShareData', //1.4.0的分享接口,注意：使用新版本的分享功能，一定要在该列表加上对应的老版本功能接口，否则新接口不起作用
      'onMenuShareAppMessage', //老版本分享接口。
      'onMenuShareTimeline', //老版本分享接口。
      'getLocation',
      'chooseImage',
      'getLocalImgData',
      'chooseWXPay',
    ]
  }

  getSignUrl() {
    return location.href.split('#')[0]
  }
  /**
   * 获取微信配置签名
   */
  init() {
    return new Promise((resolve, reject) => {
      Vue.prototype.$https
        .getWXConfig({
          // schoolId: store.state.schoolId,
          appid: store.state.appId,
          url: this.getSignUrl(),
        })
        .then((res) => {
          // console.log('数据---------', res.data)
          // this.signData = res.data
          // this.jsSDKConfig(res.data)
          if (res.code !== 200) {
            resolve('err')
          } else {
            resolve(res.data)
          }
        })
        .catch((err) => {
          resolve('err')
        })
    })
  }
  /**
   * 初始化微信sdk配置
   */
  jsSDKConfig() {
    return new Promise((resolve, reject) => {
      this.init().then((res) => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          ...res,
          // ...this.signData,
          // appId: data.appId, // 必填，公众号的唯一标识
          // timestamp: data.timestamp, // 必填，生成签名的时间戳
          // nonceStr: data.nonceStr, // 必填，生成签名的随机串
          // signature: data.signature, // 必填，签名
          jsApiList: this.jsApiList, // 必填，需要使用的JS接口列表
        })
        // 验证成功后执行的方法
        wx.ready(function() {
          console.log('分享ready')
          // share()
          resolve('ok')
        })
        wx.error(function(res) {
          console.log('配置失败', res)
          reject('err')
        })
        // 判断客户端是否支持指定js的接口
        wx.checkJsApi({
          jsApiList: this.jsApiList,
          success: function(res) {
            // return res
            console.log('判断客户端支持js接口', res)
          },
        })
      })
    })
  }
  /**
   * 分享接口
   * @param {*} params
   */
  share(params) {
    const { title, imgUrl, description, url } = params
    const tempParam = {
      title: title,
      desc: description,
      link: url,
      imgUrl: imgUrl,
      success: (res) => {
        console.log('分享成功', res)
        return Promise.resolve(res)
        // param.callBack && param.callBack(res)
      },
      cancel: function(res) {
        console.log('分享失败', res)
        return Promise.reject(res)
      },
    }
    // //分享给朋友
    wx.onMenuShareAppMessage(tempParam)
    // //分享给朋友圈
    wx.onMenuShareTimeline(tempParam)
    // // 分享给朋友
    wx.updateAppMessageShareData(tempParam)
    wx.updateTimelineShareData(tempParam)
  }
  /**
   * 选择单个图片
   */
  chooseImage() {
    return new Promise((resolve, reject) => {
      wx.chooseImage({
        count: 1, // 默认9
        sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: function(res) {
          // var localIds = res.localIds // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
          resolve(res)
        },
        fail: function() {
          reject('请确保微信权限都已开启,不然无法正常调用相机功能')
        },
      })
    })
  }

  /**
   * 选择多张图片
   */
  //  
  chooseManyImage() {
    return new Promise((resolve, reject) => {
      wx.chooseImage({
        sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: function(res) {
          // var localIds = res.localIds // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
          resolve(res)
        },
        fail: function() {
          reject('请确保微信权限都已开启,不然无法正常调用相机功能')
        },
      })
    })
  }




  /**
   * @param {*} localId 图片id
   * @returns
   * @memberof WxSDKService
   */
  getLocalImgData(localId) {
    return new Promise((resolve, reject) => {
      wx.getLocalImgData({
        localId, // 图片的localID
        success: (res) => {
          let localData = res.localData // localData是图片的base64数据，可以用img标签显示
          // 因为安卓、苹果的处理方式不同（我们不一样！），在此做了些特殊的处理！
          let self = ''
          if (localData.indexOf('data:image') == 0) {
            self = localData
          } else {
            //此处是安卓中的唯一得坑！在拼接前需要对localData进行换行符的全局替换
            self = 'data:image/jpeg;base64,' + localData.replace(/\n/g, '')
          }
          const blob = dataURLtoBlob(self)
          const file = blobToFile(blob, `${Date.parse(new Date())}.jpg`)
          resolve(file)
        },
        fail: () => {
          reject()
        },
      })
    })
  }
  /**
   * 微信支付
   * @param {*} params wx参数
   */
  chooseWXPay(params) {
    const { timeStamp, nonceStr, packageValue, signType, paySign } = params
    // alert('前端发起微信支付参数' + JSON.stringify(params))
    return new Promise((resolve, reject) => {
      wx.chooseWXPay({
        // ...params,
        timestamp: timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr, // 支付签名随机串，不长于 32 位
        package: packageValue, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign, // 支付签名
        success: function(res) {
          // 支付成功后的回调函数
          resolve(res)
        },
        error: function() {
          resolve('支付失败')
        },
        cancel: function() {
          resolve('支付取消')
        },
      })
    })
  }
}

export default new WxSDKService()
